import React from "react";

const ComingSoon = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50 text-center px-4">
      <h1 className="text-5xl font-bold text-gray-800 mb-4">
        🚧 Coming Soon
      </h1>
      <p className="text-gray-600 text-lg max-w-md">
        We’re working hard to bring you this amazing feature. Stay tuned for updates!
      </p>
      <div className="mt-8">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-300 border-t-blue-500"></div>
      </div>
    </div>
  );
};

export default ComingSoon;
